import React, { useState, useEffect, useContext } from "react";

import db from "../../services/query";

import PrintHeader from "./common/PrintHeader";
import PrintBodyTitle from "./common/PrintBodyTitle";
import PrintTable from "./common/PrintTable";
import RowPhoto from "../common/TdImg";


const FacultiesSalary = (props) => {

  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];
  const [data, setData] = useState([]);

  const columns = [
    {path: "id", label: "شماره"},
    {path: "teacher_photo", label: "عکس",  content: ({ teacher_photo }) => <RowPhoto src={teacher_photo} />,},
    {path: "aria_id", label: "کد استاد"},
    {path: "teacher_name", label: "نام"},
    {path: "salary_per_hour", label: "فی کریدت"},
    {path: "total_count", label: "حاضر"},
    {path: "salary_before_tax", label: "معاش"},
    {path: "salary_tax", label: "مالیه"},
    {path: "payable", label: "قابل پرداخت"},
    {path: "paid", label: "پرداخت شده"},
    {path: "half_year_balance", label: "باقیمانده"},
    {path: "overall_balance", label: "باقیمانده کل"},
  ];

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    const { fid, halfYear } = props.match.params;

    try {
      let query = `expenses/salary/faculties/${fid}?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        console.log(data);
        setData(data);
      });

    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <main className="main-print-wrapper faculties-salary-print">
      <PrintHeader
        title={data?.summary?.title}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <PrintTable columns={columns} data={data} />
    </main>
  );
};

export default FacultiesSalary;
